import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { deDe } from './de-de';
import { enGb } from './en-gb';
import { itIt } from './it-it';

// below values have to be in BCP 47 language tag format. In the i18n 'en' is taken as first fallback value for all english variants like 'en-US', 'en-AU' etc.
const SUPPORTED_LANGUAGES = {
  ENGLISH: 'en',
  ENGLISH_BRITISH: 'en-GB',
  GERMAN: 'de',
  ITALIAN: 'it',
} as const;

void i18n.use(initReactI18next).init({
  fallbackLng: SUPPORTED_LANGUAGES.ENGLISH,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    [SUPPORTED_LANGUAGES.ENGLISH]: { translation: enGb },
    [SUPPORTED_LANGUAGES.ENGLISH_BRITISH]: { translation: enGb },
    [SUPPORTED_LANGUAGES.GERMAN]: { translation: deDe },
    [SUPPORTED_LANGUAGES.ITALIAN]: { translation: itIt },
  },
});

export { SUPPORTED_LANGUAGES };
